import "./assets/scss/app.scss";
import WebchatWidget from "./components/WebchatWidget";

function App(): JSX.Element {
  return (
    <div className="App">
      <WebchatWidget />
    </div>
  );
}

export default App;
